import React from 'react';
import {
  CANONICAL_SPOT_SYMBOLS,
  CanonicalSpotSymbol,
  VENUE_METADATA,
  toShortSymbol,
} from '../../shared/constants/watchlist';

export interface CryptoTickerBarProps {
  selectedSymbol: string;
  onSelectSymbol: (symbol: CanonicalSpotSymbol) => void;
  compact?: boolean;
  showHotkeyHint?: boolean;
  id?: string;
  className?: string;
}

export const CryptoTickerBar: React.FC<CryptoTickerBarProps> = ({
  selectedSymbol,
  onSelectSymbol,
  compact = false,
  showHotkeyHint = false,
  id = 'crypto-ticker-bar',
  className = '',
}) => {
  return (
    <div
      id={id}
      className={`crypto-ticker-bar ${compact ? 'compact' : ''} ${className}`}
      role="tablist"
      aria-label="加密货币标的快速切换栏"
    >
      {CANONICAL_SPOT_SYMBOLS.map((sym, idx) => {
        const meta = VENUE_METADATA[sym];
        const isActive = selectedSymbol === sym;
        const short = toShortSymbol(sym);

        return (
          <button
            key={sym}
            role="tab"
            aria-selected={isActive}
            className={`crypto-ticker-pill ${isActive ? 'active' : ''}`}
            data-symbol={sym}
            onClick={() => onSelectSymbol(sym)}
            title={`${short}/USDT · ${meta.role} (${meta.venue})`}
          >
            <span className="pill-icon">{meta.icon}</span>
            <span>{short}/USDT</span>
            {showHotkeyHint && (
              <span className="pill-num">[{idx + 1}]</span>
            )}
          </button>
        );
      })}
    </div>
  );
};
